import React from 'react';
import PropTypes from 'prop-types';

const BackButton = ({ onClick, buttonText }) => {
  return (
    <div>
    <button className="vve-back-btn-oncall" onClick={onClick}>
      <div className="vve-back-arrow-icon"></div>
      <div className="vve-back-arrow-text">{buttonText}</div>
    </button>
    </div>
  );
};

BackButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  buttonText: PropTypes.string.isRequired
};

export default BackButton;
